const staticPages = {
    "es": {
        "contacto": "Contacto",
        "thankyou": "ThankYou",
        "terminos-y-condiciones": "TermsConditions",
        "politicas-de-privacidad": "PoliticasPrivacidad",
        "faqs": {
            "acerca-de-payretailers": "AcercaDePayretailers",
            "reembolsos": "Reembolsos",
            "pagos-recibos": "PagosRecibos",
        },
        "politicas-br":"",
        "ouvidoria":""
    },
    "en": {
        "contact": "Contact",
        "thankyou": "ThankYou",
        "terms-and-conditions": "TermsConditions",
        "privacy-policy": "PrivacyPolicy",
        "faqs": {
            "about-payretailers": "AboutPayRetailers",
            "refunds": "Refunds",
            "payments-receipts": "PaymentsReceipts"
        },
        "politicas-br":"",
        "ouvidoria":""
    }, 
    "pt": {
        "contato": "Contato",
        "thankyou": "ThankYou",
        "termos-e-condicoes": "TermsConditions",
        "politica-de-privacidade": "PoliticaPrivacidade",
        "faqs": {
            "sobre-payretailers": "SobrePayRetailers",
            "reembolsos": "Reembolsos",
            "pagamentos-recibos": "PagamentosRecibos"

        },
        "politicas-br":"PoliticasBr",
        "ouvidoria":"Ouvidoria"
    }, 
}

export default staticPages